import { COURSE, COURSE_API } from './Req';
import { getParamsObj } from './InterfaceCalculation';
import utils from '../lib/utils';

export class Utils {
    /**
     * 获取url参数值
     * @param name
     * @returns {*}
     */
    static getQueryString(name, url) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let matchUrl = url ? url : window.location.search;
        let r = matchUrl.substr(1).match(reg);
        if (r != null) return r[2];
        else return null;
    }

    /**
     * 获取哈希总的参数值
     * @param name
     * @returns {*}
     */
    static getHashQueryString(name) {
        let reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i');
        let r = window.location.hash.split('?') && window.location.hash.split('?').length > 1 ? window.location.hash.split('?')[1].match(reg) : null;
        if (r != null) return r[2];
        else return null;
    }

    /**
     * 过滤空过回车
     * @param str
     * @returns {*|void|string|XML}
     */
    static filterSpace(str) {
        return str.replace(/[\r\n ]/g, '');
    }

    static filterXSS(str) {
        return str
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;')
            .replace(/'/g, '&#039;');
    }

    static urlencode(data, isPrefix = false) {
        let prefix = isPrefix ? '?' : '';
        let _result = [];
        for (let key in data) {
            let value = data[key];
            // 去掉为空的参数
            if (['', undefined, null].indexOf(value) > -1) {
                continue;
            }
            if (value.constructor === Array) {
                value.forEach(_value => {
                    _result.push(encodeURIComponent(key) + '[]=' + encodeURIComponent(_value));
                });
            } else {
                _result.push(encodeURIComponent(key) + '=' + encodeURIComponent(value));
            }
        }
        return _result.length ? prefix + _result.join('&') : '';
    }

    //判断当前浏览器是否支持webp
    // check_webp_feature:
    // 'feature' can be one of 'lossy', 'lossless', 'alpha' or 'animation'.
    //   'callback(feature, result)' will be passed back the detection result (in an asynchronous way!)
    static checkWebpFeature(feature, callback) {
        let kTestImages = {
            lossy: 'UklGRiIAAABXRUJQVlA4IBYAAAAwAQCdASoBAAEADsD+JaQAA3AAAAAA',
            lossless: 'UklGRhoAAABXRUJQVlA4TA0AAAAvAAAAEAcQERGIiP4HAA==',
            alpha: 'UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAARBxAR/Q9ERP8DAABWUDggGAAAABQBAJ0BKgEAAQAAAP4AAA3AAP7mtQAAAA==',
            animation: 'UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA',
        };
        let img = new Image();
        img.onload = function () {
            let result = img.width > 0 && img.height > 0;
            callback(feature, result);
        };
        img.onerror = function () {
            callback(feature, false);
        };
        img.src = 'data:image/webp;base64,' + kTestImages[feature];
    }

    static getElementOffsetTop(el) {
        let actualTop = el.offsetTop;
        let current = el.offsetParent;
        while (current !== null) {
            actualTop += current.offsetTop;
            current = current.offsetParent;
        }
        return actualTop;
    }

    static getElementOffsetLeft(el) {
        let actualLeft = el.offsetLeft;
        let current = el.offsetParent;
        while (current !== null) {
            actualLeft += current.offsetLeft;
            current = current.offsetParent;
        }
        return actualLeft;
    }

    static base64(input) {
        return window.btoa(unescape(encodeURIComponent(input)));
    }

    // static base64(content) {
    //     return new Buffer(content).toString('base64')
    // }

    static loadJs(url, callback) {
        var script = document.createElement('script');
        script.type = 'text/javascript';
        if (typeof callback !== 'undefined') {
            if (script.readyState) {
                script.onreadystatechange = function () {
                    if (script.readyState === 'loaded' || script.readyState === 'complete') {
                        script.onreadystatechange = null;
                        callback();
                    }
                };
            } else {
                script.onload = function () {
                    callback();
                };
            }
        }
        script.src = url;
        document.body.appendChild(script);
    }

    /**
     * 设置某个cookie的值
     * @param {string} key cookie的名称
     * @param {string} value cookie的值
     * @param {integer} [hours] 超时时间  如果不提供cookie的随浏览器进程存在，浏览器关闭则cookie失效
     * @param domain
     * @param path
     * @return {string} cookie信息
     */
    static setCookie(name, value, hours, domain, path) {
        var expire = '';

        if (hours instanceof Date) {
            expire = '; expires=' + hours.toGMTString();
        } else if (hours != null) {
            expire = new Date(new Date().getTime() + hours * 3600000);
            expire = '; expires=' + expire.toGMTString();
        }

        if (typeof domain === 'undefined') {
            domain = '';
        } else {
            domain =
                '; domain=' + (domain.indexOf('putaoabc.com') > -1 ? '.putaoabc.com' : domain.indexOf('putaoabc.net.cn') > -1 ? '.putaoabc.net.cn' : (domain.indexOf('bubuaike.com') > -1 ? '.bubuaike.com' : domain));
        }

        if (typeof path === 'undefined') {
            path = '';
        } else {
            path = '; path=' + path;
        }

        document.cookie = name + '=' + encodeURIComponent(value) + expire + domain + path;
    }

    /**
     * 获取某个cookie的值
     * @param {string} key cookie的名称
     * @return {string} cookie值
     */
    static getCookie(key) {
        key = encodeURIComponent(key);
        var cookies = document.cookie.split(';');
        for (var i = 0, len = cookies.length; i < len; i++) {
            var parts = cookies[i].split('='),
                name = decodeURIComponent(parts.shift()),
                cookie = parts.join('=');

            if (key === name.replace(/^\s+|\s+$/g, '')) {
                try {
                    return decodeURIComponent(cookie);
                } catch (e) {
                    //兼容历史base库中用escape编码的cookie
                    cookie = unescape(cookie);
                    return cookie;
                }
            }
        }
        return '';
    }

    /**
     * 删除cookie
     * @param {string} key cookie名称
     * @param domain
     * @param path
     */
    static delCookie(name, domain, path) {
        var expire = '; expires=Mon, 26 Jul 1997 05:00:00 GMT';

        if (typeof domain === 'undefined') {
            domain = '';
        } else {
            domain = '; domain=' + (domain.indexOf('putaoabc.com') > -1 ? '.putaoabc.com' : domain);
        }

        if (typeof path === 'undefined') {
            path = '';
        } else {
            path = '; path=' + path;
        }

        document.cookie = name + '=' + expire + domain + path;
    }

    /**
     * 学习报告，收集数据
     * putaoid，cid, starttime, actionId,
     * actionType (ASRandJudge_等其他),
     * fbType （成功的话发succ（语音交互以外的））, 语音交互传空
     * score （语音交互，传回来他的得分），语音交互之外的传0
     * knowledge  回传actions[key]下的knowledge
     */
    static reportRecord(startTime, actionId, actionType, fbType, score, knowledge) {
        if (window.location.hash.indexOf('review' === -1)) {
            try {
                let cid = Utils.getHashQueryString('cid');
                let putaoid = Utils.getCookie('putaoid');
                let token = encodeURIComponent(Utils.getCookie('token'));
                fetch(
                    new Request(
                        COURSE +
                        `/report_record?putaoid=${putaoid}&token=${token}&cid=${cid}&starttime=${startTime}&actionId=${actionId}&actionType=${actionType}&fbType=${fbType}&score=${score}&from=pc`,
                        {
                            method: 'POST',
                            body: JSON.stringify({ knowledge: knowledge }),
                        }
                    )
                )
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (res) {
                        // console.log('f:', res)
                    });
            } catch (error) { }
        }
    }
    static newReportRecord(params, body) {
        if (window.location.hash.indexOf('review' === -1)) {
            try {
                const paramsStr = getParamsObj();
                fetch(
                    new Request(`${COURSE_API.report_record}?${this.setJsonToUrl(Object.assign(paramsStr, params))}`, {
                        method: 'POST',
                        body: JSON.stringify(body),
                    })
                )
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (res) {
                        // console.log('f:', res)
                    });
            } catch (error) { }
        }
    }


    /**
     * 勋章上报
     */
    static encourageRecord(params, body) {
        if (window.location.hash.indexOf('review' === -1)) {
            try {
                const paramsStr = getParamsObj();
                fetch(
                    new Request(`${COURSE_API.encourage_record}?${this.setJsonToUrl(Object.assign(paramsStr, params))}`, {
                        method: 'POST',
                        body: body ? JSON.stringify(body) : "",
                    })
                )
                    .then(function (response) {
                        return response.json();
                    })
                    .then(function (json) {
                        if (json && json.code === 200 && json.data && json.data.medalInfos && json.data.medalInfos instanceof Array && json.data.medalInfos.length) {
                            Utils.giveMedalList(json.data.medalInfos)
                        }
                    });
            } catch (error) { }
        }
    }

    // 给勋章
    static giveMedalList(medalInfos) {
        for (let i = 0; i < medalInfos.length; i++) {
            const medalInfo = medalInfos[i];
            const medalList = document.getElementById(`medal_${medalInfo.medalId}`);
            if (medalList && medalList.className === "gray") {
                medalList.className = "give";
            }
        }
    }

    /**
     * 给积分
     * @param {*} type 1-带done模板+圈图，按轮数给分。；2-不带done操作的交互模板，按时间给分.3-语音题，按向日葵笑脸给分
     * @param {*} options 
     */
    static giveIntegrals(type, options) {
        const { totalTime, useTime, roundNum, fbType, smileNum } = options;
        const integrals_num = document.getElementById("integrals_num");
        const integrals_add = document.getElementById("integrals_add");
        if (integrals_num) {
            window.curIntegrals = 1;
            let integrals = parseInt(integrals_num.innerText, 10);
            if (type === 2) {
                const useTimePercent = useTime / totalTime;
                if (useTimePercent <= 0.6 && useTimePercent > 0.3) {
                    window.curIntegrals = 2;
                } else if (useTimePercent <= 0.3 && useTimePercent > 0) {
                    window.curIntegrals = 5;
                } else {
                    window.curIntegrals = 1;
                }
            } else if (type === 3) {
                window.curIntegrals = smileNum === 3 && roundNum === 1 ? 5 : smileNum;
            } else {
                window.curIntegrals = fbType === "succ" ? (roundNum === 1 ? 5 : 3) : 1;
            }
            integrals = integrals + window.curIntegrals;
            window.integrals = integrals;
            setTimeout(() => {
                integrals_num.innerText = integrals;
                if (integrals_add && window.curIntegrals > 0) {
                    integrals_add.className = "integrals_add";
                    integrals_add.innerText = `+${window.curIntegrals}`;
                    integrals_add.addEventListener("animationend", () => {
                        integrals_add.className = "";
                        integrals_add.innerText = "";
                    });
                }
            }, 1500);
        }
    }


    /**
     * 上报 pingBack
     */
    static postPingBack(body, params, type) {
        let opts = {
            method: 'POST', //请求方法
            body: this.urlencode(body), //请求体
        };
        let url = type ? `/${type}/cl.gif` : '/pb/cl.gif';
        if (params && typeof params === 'object') {
            url += '?' + this.setJsonToUrl(params);
        }

        fetch(new Request(url, opts))
            .then(response => {
                return response.text();
            })
            .then(responseText => {
                // console.log('responseText:', responseText);
            });
    }

    /**
     * 发送统计
     * situation2，记录每次进入和离开课堂
     */
    static sendStatRequest(url, json) {
        fetch(
            new Request(`${COURSE}${url}?${this.setJsonToUrl(json)}`, {
                method: 'GET',
            })
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (res) { });
    }

    /**
     * 将json转为url参数
     */
    static setJsonToUrl(ojson) {
        var s = '',
            name,
            key;
        for (var p in ojson) {
            // if (!ojson[p]) {
            //     return null;
            // }
            if (ojson.hasOwnProperty(p)) {
                name = p;
            }
            key = ojson[p];
            s += '&' + name + '=' + encodeURIComponent(key);
        }
        return s.substring(1, s.length);
    }

    //获取指定区间范围随机数，包括lowerValue和upperValue
    static randomFrom(lowerValue, upperValue) {
        return Math.floor(Math.random() * (upperValue - lowerValue + 1) + lowerValue);
    }

    //获取uuid
    static getUUID() {
        return 'xxxxxxxx-8xxx-yxxx-xxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = (Math.random() * 16) | 0,
                v = c === 'x' ? r : (r & 0x3) | 0x8;
            return v.toString(16).toLocaleUpperCase();
        });
    }

    //求数组的平均值
    static arrayAvg(array) {
        //将array的长度赋给len
        var len = array.length;
        var sum = 0;
        //利用for循环遍历数组的内容，利用sum累加求和
        for (var i = 0; i < len; i++) {
            sum += array[i];
        }
        return sum / len;
    }

    //求数组的和
    static arraySum(array) {
        if (array && array.length) {
            return array.reduce((total, num) => {
                return total + num;
            });
        }
        // let s = 0;
        // if (arr.length == 0) {
        //     return 0;
        // } else if (arr.length == 1) {
        //     return arr[0];
        // } else {
        //     for (let i = 0; i < arr.length; i++) {
        //         s += arr[i];
        //     }
        //     return s;
        // }
    }

    //求某个元素在数组中出现的次数
    static countItemInArray(array, item) {
        if (array && array.length) {
            return array.reduce((a, v) => (v === item ? a + 1 : a + 0), 0);
        }
    }

    //通过value删除数组项
    static deleteValueFromArray(arr, val) {
        for (var i = 0; i < arr.length; i++) {
            if (arr.indexOf(val) > -1 && arr[i] == val) {
                arr.splice(i, 1);
            }
        }
    }

    //获取设备信息
    static getDevice() {
        try {
            var ua = navigator.userAgent.toLowerCase();
            var re = /(msie|firefox|chrome|opera|version).*?([\d.]+)/;
            var m = ua.match(re);
            return ua.match(/\(.*?\)+/)[0] + ' ' + m[1].replace(/version/, "'safari") + ' ' + m[2];
        } catch (err) {
            return ua;
        }
    }

    /**
     * 页面的缩放
     * 1.1: 740-805
     * 1.2: 805-865
     * 1.3: 865-930
     * 1.4: 930-
     */
    static zoomPage(tagId) {
        let root = document.getElementById('root');
        let rootH = root.clientHeight;
        let bodyW = document.documentElement.clientWidth; //window.screen.availWidth;
        let bodyH = document.documentElement.clientHeight; //parseInt(window.screen.availHeight);
        let screenState = 0;
        const ua = this.getDevice();
        if (window.orientation == 180 || window.orientation == 0) {
            //竖屏状态！
        }
        if (window.orientation == 90 || window.orientation == -90) {
            //横屏状态！
            if (ua.indexOf('iphone') > -1 || ua.indexOf('ipad') > -1) {
                screenState = 1;
                // bodyH = bodyH - 150;
            } else if (ua.indexOf('android') > -1) {
                // bodyH = bodyH - 70;
            }
        }
        let useSize;
        if (bodyW / bodyH > 1024 / 630) {
            //宽屏，用高度计算
            useSize = bodyH / 630;
        } else {
            //高屏幕，用宽度算
            // useSize = (screenState === 1 ? bodyH : bodyW) / 1024;    //用 bodyH = window.screen.availHeight 时，在ios下横屏时候的屏幕宽度也是取的屏幕高，因此用 bodyH 代替 bodyW
            useSize = bodyW / 1024;
        }
        root.style.zoom = useSize;
        root.style.top = (bodyH / useSize - rootH) / 2 + 'px';
    }

    /**
     * 通过字符串key的形式查找value
     * 如：0.1.2
     */
    static getJsonValUseStrKey(obj, key) {
        if (typeof key === 'number') key = key.toString();
        if (key && key.indexOf('.') > -1) {
            return key.split('.').map(p => (obj = obj && obj[p])), obj;
        } else {
            return obj[key];
        }
    }

    static formatDate(fmt) {
        var _this = new Date();
        var o = {
            'M+': _this.getMonth() + 1, //月份
            'd+': _this.getDate(), //日
            'h+': _this.getHours(), //小时
            'm+': _this.getMinutes(), //分
            's+': _this.getSeconds(), //秒
            'q+': Math.floor((_this.getMonth() + 3) / 3), //季度
            S: _this.getMilliseconds(), //毫秒
        };
        if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (_this.getFullYear() + '').substr(4 - RegExp.$1.length));
        for (var k in o)
            if (new RegExp('(' + k + ')').test(fmt)) fmt = fmt.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ('00' + o[k]).substr(('' + o[k]).length));
        return fmt;
    }

    /**
     * 查找数组项是对象中某个key的值
     * @param {*} arr 数组
     * @param {*} value 要查找的值
     * @param {*} key 要查找的key
     */
    static getItemKeyInArrayObject(arr, value, key) {
        if (arr && arr instanceof Array && arr.length && arr.length > 0) {
            for (let i = 0; i < arr.length; i++) {
                let arrItem = arr[i];
                if (arrItem && ((key && arrItem[key] && arrItem[key] === value) || arrItem === value)) {
                    return i;
                }
            }
        }
    }

    /**
     * 判断是否是 360
     *
     * 注：360 的 navigator.userAgent 与 chrome 一模一样，不能区分。且下面的方法不能区分 mac 版的 360极速浏览器
     */
    static testIs360() {
        const ua = navigator.userAgent.toLocaleLowerCase();

        // 如果不是和谷歌一样的 ua，就一定不是 360
        if (ua.indexOf('chrome') < 0) {
            return false;
        }

        const mimeTypes = navigator.mimeTypes ? navigator.mimeTypes : null;
        const plugins = navigator.plugins ? navigator.plugins : null;

        // windows下：只有360安全浏览器支持这个mate
        if (mimeTypes) {
            for (var keyMime in mimeTypes) {
                if (mimeTypes[keyMime] && mimeTypes[keyMime].type && mimeTypes[keyMime].type === 'application/vnd.chromium.remoting-viewer') {
                    return true;
                }
            }
        }

        // windows下： 360极速浏览器有这个插件
        if (plugins) {
            for (var keyPlugin in plugins) {
                if (mimeTypes[keyPlugin] && mimeTypes[keyPlugin].filename && mimeTypes[keyPlugin].filename === 'np-mswmp.dll') {
                    return true;
                }
            }
        }

        return false;
    }

    /**
     * 获取需要下载的课程列表
     * @param {string} cid 
     */
    static getNeedDownloadVideoList(params, callback) {
        if (!navigator.onLine) {
            utils.showTips("无网络，请检查网络连接是否正常！", 3000);
            return;
        }
        fetch(
            new Request(`${COURSE_API.video_list}?${this.setJsonToUrl(params)}`, {
                method: 'GET',
            })
        )
            .then(function (response) {
                return response.json();
            })
            .then(function (res) {
                if (res && typeof res === 'object' && res.code === 200 && res.lessons && res.lessons instanceof Array && res.lessons.length && callback && typeof callback === "function") {
                    callback(res.lessons);
                }
            }).catch(function (err) {
            });
    }

    static insidePolygon(point, polygon) {
        // ray-casting algorithm based on
        // http://www.ecse.rpi.edu/Homepages/wrf/Research/Short_Notes/pnpoly.html

        var x = point[0], y = point[1];

        var inside = false;
        for (var i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
            var xi = polygon[i][0], yi = polygon[i][1];
            var xj = polygon[j][0], yj = polygon[j][1];

            var intersect = ((yi > y) != (yj > y))
                && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
            if (intersect) inside = !inside;
        }

        return inside;
    }
}



// WEBPACK FOOTER //
// ./src/utils/Utils.js